import React from 'react';
import { useStore } from '../stores';
import { observer } from 'mobx-react-lite';
import { Favourites } from './overlayButtons/favourites';
import { Filter } from './overlayButtons/filter';
import { TextSearch } from './overlayButtons/text-search';
import { Parking } from './overlayButtons/parking';

export const MapOverlay = observer(({ mapReference }) => {
  const { config, layers, favourites, parking, myLocations } = useStore();

  return (
    <div className="p-5 flex justify-between absolute top-0 right-0 left-0 z-10 lg:left-[300px]">

      <div className="flex">
        <TextSearch layers={layers} config={config} />
      </div>

      <div className="flex">

        <Parking config={config} parking={parking} map={mapReference} />

        <Favourites
          layers={layers}
          config={config}
          favourites={favourites}
          myLocations={myLocations}
        />

        <Filter layers={layers} />
        
      </div>

    </div>
  );
});
